import pbkdf2 from 'pbkdf2';

function hashPassword(pass) {
    return pbkdf2.pbkdf2Sync(pass, 'hX97NfkS5PaNv4TWrAevcbJrvrnJsMFH', 5000, 32, 'sha1').toString('hex'); 
}

export default hashPassword